import { apiService } from './api';
import { ApiResponse } from '@/types/api';

export interface Platform {
  id: number;
  platformName: string;
  platformDisplayName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PlatformsResponse extends ApiResponse<{
  platforms: Platform[];
  totalPlatforms: number;
}> {}

export interface PlatformCategory {
  id: number;
  category_name: string;
  isActive: boolean;
  is_completed: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PlatformCategoriesResponse extends ApiResponse<{
  categories: PlatformCategory[];
  totalCategories: number;
}> {}

export class PlatformService {
  /**
   * Get all available platforms
   */
  async getPlatforms(): Promise<PlatformsResponse> {
    return apiService.get<PlatformsResponse>('/platforms');
  }

  /**
   * Get all platform categories
   */
  async getCategories(): Promise<PlatformCategoriesResponse> {
    return apiService.get<PlatformCategoriesResponse>('/platforms/categories');
  }
}

export const platformService = new PlatformService();